import React from 'react';
import styled from 'styled-components';

const InputContainer = styled.div<{ backgroundColor: string; largeText?: boolean }>`
	position: relative;
	height: 100%;
	input {
		width: 100%;
		height: 100%;
		border: 1px solid #969696;
		padding-left: 0.5em;
		${(props) => (props.largeText ? 'font-size: 1.6em;' : '')}
	}
	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active {
		-webkit-box-shadow: 0 0 0 30px white inset !important;
	}
	textarea:focus,
	input:focus {
		outline: none;
	}
	input[readonly] {
		background-color: ${(props) => props.backgroundColor};
	}
	.input-wrapper {
		height: 100%;
		position: relative;
	}
	.text-wrapper {
		margin-top: -13px;
		margin-left: 5px;
		position: absolute;
		top: 0;
		left: 0;
		span {
			color: #969696;
			background-color: ${(props) => props.backgroundColor};
			padding: 0 0.4em 0 0.4em;
			height: 1em;
		}
	}
`;

interface StyledInputProps {
	backgroundColor: string;
	title?: string;
	name: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	largeText?: boolean;
	value?: string;
	readOnly?: boolean;
}

export const StyledInput: React.FC<StyledInputProps> = (props: StyledInputProps) => (
	<InputContainer backgroundColor={props.backgroundColor} largeText={props.largeText}>
		<div className={'input-wrapper'}>
			{props.title && (
				<div className={'text-wrapper'}>
					<span>{props.title}</span>
				</div>
			)}
			<input name={props.name} onChange={props.onChange} value={props.value} readOnly={props.readOnly} />
		</div>
	</InputContainer>
);

interface StyledPasswordInputProps {
	backgroundColor: string;
	title: string;
	name: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	largeText?: boolean;
	value?: string;
}

export const StyledPasswordInput: React.FC<StyledPasswordInputProps> = (props: StyledPasswordInputProps) => (
	<InputContainer backgroundColor={props.backgroundColor} largeText={props.largeText}>
		<div className={'input-wrapper'}>
			<div className={'text-wrapper'}>
				<span>{props.title}</span>
			</div>
			<input name={props.name} type="password" value={props.value} onChange={props.onChange} />
		</div>
	</InputContainer>
);
